// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__TyOc9","noInteraction":"EventWrapper_noInteraction__3Hl3n"};